import { USER_ITEM_SUPPORT_EMAIL } from '../../../constants/user'
import { getHtmlEmailLink } from '../../../utils/link'

export function getGretaAIChatSupportEmailLink(subject) {
  return `${getHtmlEmailLink(USER_ITEM_SUPPORT_EMAIL)}?subject=${encodeURIComponent(subject)}`
}
